import { CancelledError } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'
import { transactionsQueryOptions } from '#pages/support/payouts'

export const Route = createFileRoute('/support/payouts')({
  loader: async ({ context }) => {
    const { queryClient } = context

    try {
      await queryClient.ensureInfiniteQueryData(transactionsQueryOptions)
    } catch (error) {
      if (error instanceof CancelledError) return
      throw error
    }
  },
})
